import React from 'react';
import { Validation } from '../../../ReusableComponents/NewDesign/Layout/Layout';

function VendorApplication() {
  return (
    <Validation
      title="Thank You. Your vendor invitation has been sent to the listed vendor."
      text="You will be shortly receiving an email confirmation."
    />
  );
}

export default VendorApplication;
